import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import Services from "./Components/Services";
import Apropos from "./Components/Apropos";
import Packs from "./Components/Packs";
import Actualites from "./Components/Actualites";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer"; // ← استيراد Footer

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/Apropos" element={<Apropos />} />
        <Route path="/Packs" element={<Packs />} />
        <Route path="/Actualites" element={<Actualites />} />
        <Route path="/Contact" element={<Contact />} />
        
      </Routes>

     
      <Footer />
    </BrowserRouter>
  );
}

export default App;
